import React from "react";
import { Col, Container, Row, Tabs, Tab } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

const Technologygcc = () => {
  return (
    <div className="tabing_section healthcare_tabs_sec p-100">
      <Container>
        <Row>
          <Col xs={12} md={9} lg={8} className="m-auto text-center">
            <h3 className="h3_head">
              Our Tech Stack for <span>WooCommerce Web Development</span>{" "}
              Services
            </h3>
            <p>
              Our WooCommerce Web Development Services deliver secure, fast, and
              scalable websites using a precision-engineered tech stack. We
              specialize in seamless integrations, custom functionality, and
              optimized performance. Rely on our expertise for deploying,
              maintaining, and scaling your WooCommerce site with the latest
              technologies.
            </p>
          </Col>
        </Row>
        <Row>
          <Tabs defaultActiveKey="1" id="uncontrolled-tab-example">
            <Tab eventKey="1" title="Frontend">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/woocommerce/frontend/NextJs.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>NextJs</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/woocommerce/frontend/Bootsrap.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>Bootstrap</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/woocommerce/frontend/Reactnative.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>React</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/woocommerce/frontend/sass.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>Sass</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/woocommerce/frontend/Tailwind_CSS.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>Tailwind CSS</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/woocommerce/frontend/vue.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>Vue Js</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="2" title="Backend">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/woocommerce/backend/laravel.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>Laravel</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/woocommerce/backend/Node-js.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>Node Js</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/woocommerce/backend/Php.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>Php</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="3" title="Database">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/ecommerce_web/database/my_sql.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>MySQL</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/ecommerce_web/database/MongoDB.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>MongoDB</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/ecommerce_web/database/PostgreSQL.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>PostgreSQL</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="4" title="Cloud">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/woocommerce/cloud/AWS.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>AWS</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/woocommerce/cloud/docker.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Docker</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/woocommerce/cloud/google_cloud_platform.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Google Cloud</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/woocommerce/cloud/kubernets.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>kubernets</h6>
                  </div>
                </li>
              </ul>
            </Tab>
          </Tabs>
        </Row>
      </Container>
    </div>
  );
};

export default Technologygcc;
